module.exports = __webpack_public_path__ + "4f1afb3001d0609a99c3580fc9dd46ec.svg";